// i18m文件夹下新建index.js
import Vue from 'vue'
import Vuei18n from 'vue-i18n'
Vue.use(Vuei18n)
import zh from './zh.js'
import en from './en.js'

function getLanguageFromDomain() {
  const currentURL = window.location.href;
  // 判断并设置 preferredLang
  if (currentURL.includes('cn-northwest')) {
    localStorage.setItem('preferredLang', 'zh');
    return 'zh';
  } else if (currentURL.includes('ap-east')) {
    localStorage.setItem('preferredLang', 'en');
    return 'en';
  } else if (!localStorage.getItem('preferredLang')) {
    if (currentURL.includes('.com')) {
      localStorage.setItem('preferredLang', 'en');
    } else if (currentURL.includes('.cn')) {
      localStorage.setItem('preferredLang', 'zh');
    }
  }
  // 默认返回英文
  return localStorage.getItem('preferredLang') || 'en';
}

const i18n = new Vuei18n({
  locale: getLanguageFromDomain(), // 语言
  messages: { // 文案
    zh, // 文案的中文版
    en // 文案的英文版
  }
})
export default i18n